// Copyright (c) 2025 by Audere

import { Box } from "@mui/material";
import React from "react";
import {
  AddQCFeedbackRequest,
  LabelingRole,
  UpdateLabelRequest,
} from "../../features/api/labelApiSlice";
import { LabelTask } from "../../features/label/labelTypes";
import LabelingForm from "./LabelingForm";
import { useAppSelector } from "../../features/store";
import { getQCCorrection } from "../../utils/taskUtils";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useParams } from "react-router";

interface ConversationLabelsProps {
  task: LabelTask;
  debugEnabled?: boolean;
  onSave: (payload: UpdateLabelRequest | AddQCFeedbackRequest) => void;
}

const ConversationLabels: React.FC<ConversationLabelsProps> = ({
  debugEnabled,
  task,
  onSave,
}) => {
  const qcCorrectLabels = useAppSelector(
    (state) => state.label.qcCorrectLabels
  );
  const isCorrect = getQCCorrection(qcCorrectLabels, task.id);
  const { isQC, isMonitor } = useCurrentUser();
  const { conversationUID } = useParams<{ conversationUID: string }>();

  return (
    <Box sx={{ display: "flex", justifyContent: "space-around" }}>
      <LabelingForm
        key={`labeler-${conversationUID}-${task.id}`}
        task={task}
        debugEnabled={debugEnabled}
        formProvider={LabelingRole.conversation_labeler}
        onSave={onSave}
      />
      {((isCorrect === false && isQC) || isMonitor) && (
        <LabelingForm
          key={`qc-labeler-${conversationUID}-${task.id}`}
          task={task}
          debugEnabled={debugEnabled}
          formProvider={LabelingRole.conversation_label_qc}
          onSave={onSave}
        />
      )}
    </Box>
  );
};

export default ConversationLabels;
